import { DrawingController } from "./Controllers/DrawingController";
import { DataActionController } from "./Controllers/DataActionController";
import { EventHandler } from "./Controllers/EventHandler";
import { ImageFilter } from "./Controllers/ImageFilter";
import FloorplanView from "./Classes/FloorplanView";

(function () {
  function init() {
    window.DrawingController = DrawingController;
    window.DataActionController = DataActionController;
    window.EventHandler = EventHandler;

    // // Binding mousedown event. when ever user click on html area, this function is called;
    // document.addEventListener("mousedown", EventHandler.mousedown, false);

    const mbFloorplans = document.querySelector(".mb-floorplan");
    if (!mbFloorplans || !mbFloorplans.id) return;

    window.FloorplanView = new FloorplanView(mbFloorplans.id);
    window.FloorplanView.initFloorplan();

    ImageFilter.initFilters();

    document.addEventListener("scroll", function (event) {
      if (document.body.classList.contains("floorplan-dragging")) {
        event.preventDefault();
        event.stopPropagation();
        return false;
      }
    });
  }
  init();
})();
